import bootbox from 'bootbox';
import React from 'react';
import configure from './configure';
import AppRouter from './routers/AppRouter';
import './styles/_bootstrap.scss';
import 'bootstrap/dist/js/bootstrap.min';
// import 'bootstrap/scss/bootstrap.scss';
import 'animate.css/animate.min.css';
import './styles/_index.scss';

bootbox.setDefaults({ locale: 'fa' });
configure();

function App() {
  return (
    <React.Fragment>
      <AppRouter />
    </React.Fragment>
  );
}

export default App;
